<div class="tw-flex tw-h-full tw-flex-col">
  <div class="unified-tool-header">
    <div class="header-content">
      <div class="header-icon">
        <svg viewBox="0 0 24 24" class="tool-icon">
          <path
            d="M14,17H7V15H14M17,13H7V11H17M17,9H7V7H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
          />
        </svg>
      </div>
      <div class="header-text">
        <h1>Settings</h1>
        <p>{{ headerSubtitle }}</p>
      </div>
    </div>
  </div>

  <div class="tool-content">
    <!-- Persona selection -->
    <div *ngIf="step === 'personas'">
      <div class="tw-mb-5">
        <button
          type="button"
          class="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-xl tw-border-2 tw-border-slate-200 tw-bg-slate-50 tw-px-3.5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-slate-500 hover:tw-border-blue-600 hover:tw-bg-blue-600 hover:tw-text-white"
          (click)="backToEventSettings()"
        >
          <svg viewBox="0 0 24 24" class="tw-h-4 tw-w-4 tw-fill-current">
            <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
          </svg>
          <span>Back to event settings</span>
        </button>
      </div>

      <div *ngIf="isLoadingForms" class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-px-5 tw-py-[60px] tw-text-center">
        <div class="tw-h-10 tw-w-10 tw-animate-spin tw-rounded-full tw-border-[3px] tw-border-gray-200 tw-border-t-blue-600"></div>
        <p>Loading personas...</p>
      </div>

      <div class="tw-grid tw-grid-cols-[repeat(auto-fill,minmax(240px,1fr))] tw-gap-4" *ngIf="!isLoadingForms && personas.length > 0">
        <button
          type="button"
          class="tw-flex tw-cursor-pointer tw-flex-col tw-gap-2 tw-rounded-2xl tw-border tw-border-dashed tw-border-slate-300 tw-bg-white tw-p-5 tw-text-left tw-transition hover:tw--translate-y-0.5 hover:tw-border-solid hover:tw-border-blue-600 hover:tw-shadow-[0_8px_20px_rgba(31,111,224,0.12)]"
          *ngFor="let persona of personas"
          (click)="selectPersona(persona)"
        >
          <h3 class="tw-m-0 tw-text-base tw-text-slate-900">{{ getPersonaDisplayName(persona) }}</h3>
          <span class="tw-text-[13px] tw-text-slate-500">{{ getPersonaType(persona) }} form · {{ getFieldCount(persona) }} fields</span>
          <span class="tw-mt-2 tw-text-[13px] tw-font-bold tw-text-blue-600">Select persona</span>
        </button>
      </div>

      <div *ngIf="!isLoadingForms && personas.length === 0" class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-px-5 tw-py-[60px] tw-text-center">
        <h3 class="tw-m-0 tw-text-slate-900">No personas found</h3>
        <p class="tw-m-0 tw-text-slate-500">This event has no registration forms.</p>
      </div>
    </div>

    <!-- Editor -->
    <div *ngIf="step === 'editor'">
      <div class="tw-mb-5">
        <button
          type="button"
          class="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-xl tw-border-2 tw-border-slate-200 tw-bg-slate-50 tw-px-3.5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-slate-500 hover:tw-border-blue-600 hover:tw-bg-blue-600 hover:tw-text-white"
          *ngIf="entityType === 'event'"
          (click)="backToEvents()"
        >
          <svg viewBox="0 0 24 24" class="tw-h-4 tw-w-4 tw-fill-current">
            <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
          </svg>
          <span>Back to events</span>
        </button>
        <button
          type="button"
          class="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-xl tw-border-2 tw-border-slate-200 tw-bg-slate-50 tw-px-3.5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-slate-500 hover:tw-border-blue-600 hover:tw-bg-blue-600 hover:tw-text-white"
          *ngIf="entityType === 'form'"
          (click)="backToPersonas()"
        >
          <svg viewBox="0 0 24 24" class="tw-h-4 tw-w-4 tw-fill-current">
            <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
          </svg>
          <span>Select different persona</span>
        </button>
      </div>

      <div class="tw-mb-4 tw-text-sm tw-text-slate-500">
        <span *ngIf="selectedEvent?.name">Event: <strong class="tw-text-slate-900">{{ selectedEvent?.name }}</strong></span>
        <span *ngIf="selectedForm"> · Persona: <strong class="tw-text-slate-900">{{ getPersonaDisplayName(selectedForm) }}</strong></span>
      </div>

      <div *ngIf="isLoadingOptions" class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-px-5 tw-py-[60px] tw-text-center">
        <div class="tw-h-10 tw-w-10 tw-animate-spin tw-rounded-full tw-border-[3px] tw-border-gray-200 tw-border-t-blue-600"></div>
        <p>Loading settings...</p>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-4" *ngIf="!isLoadingOptions">
        <div class="tw-flex tw-items-start tw-justify-between tw-gap-5 max-md:tw-flex-col">
          <div class="tw-min-w-0 tw-flex-1">
            <h2 class="tw-mb-1.5 tw-mt-0 tw-text-lg tw-text-slate-900">
              {{ entityType === 'event' ? 'Event settings' : 'Settings' }}
              <span *ngIf="loadedEntityLabel" class="tw-font-medium tw-text-slate-500">({{ loadedEntityLabel }})</span>
            </h2>
            <p class="tw-m-0 tw-text-[13px] tw-text-slate-500">
              Only settings returned by the API are shown. Use Add chips in each section to include more, then save.
            </p>
          </div>

          <div class="tw-m-0 tw-ml-auto tw-w-[280px] tw-shrink-0 max-md:tw-ml-0 max-md:tw-w-full" *ngIf="showPersonaEntry">
            <p class="tw-mb-3 tw-mt-0 tw-text-sm tw-font-semibold tw-text-slate-700">Also update</p>
            <div class="tw-grid tw-grid-cols-1 tw-gap-3">
              <button
                type="button"
                class="tw-flex tw-w-full tw-cursor-pointer tw-flex-col tw-items-start tw-gap-1 tw-rounded-xl tw-border-2 tw-border-slate-200 tw-bg-white tw-px-4 tw-py-3.5 tw-text-left tw-transition hover:tw-border-blue-300"
                (click)="openPersonaSettings()"
              >
                <span class="tw-text-[15px] tw-font-bold tw-text-slate-900">Persona</span>
                <span class="tw-text-xs tw-text-slate-500">Settings for a registration form</span>
              </button>
            </div>
          </div>
        </div>

        <div class="tw-rounded-xl tw-border tw-border-red-200 tw-bg-red-50 tw-px-3.5 tw-py-3" *ngIf="pendingUnset.length">
          <strong class="tw-text-[13px] tw-text-red-800">Will be removed on save:</strong>
          <ul class="tw-mb-0 tw-mt-2 tw-list-disc tw-pl-[18px] tw-font-mono tw-text-xs tw-text-red-900">
            <li *ngFor="let path of pendingUnset">{{ path }}</li>
          </ul>
        </div>

        <ngx-options-tree-editor
          *ngIf="showSettingsEditor"
          [node]="editableOptions"
          [groups]="settingsGroups"
          [defaults]="settingsDefaults"
          [hideKeys]="hiddenSettingKeys"
          [hideOther]="entityType === 'form'"
          [scope]="entityType === 'event' ? 'event' : entityType === 'form' ? 'form' : ''"
          (unsetPath)="onUnsetPath($event)"
          (restorePath)="onRestorePath($event)"
        >
        </ngx-options-tree-editor>

        <div class="tw-rounded-xl tw-border tw-border-dashed tw-border-slate-300 tw-bg-slate-50 tw-px-5 tw-py-10 tw-text-center" *ngIf="!showSettingsEditor">
          <h3 class="tw-mb-1.5 tw-mt-0 tw-text-slate-900">No settings yet</h3>
          <p class="tw-m-0 tw-text-slate-500">This item has an empty options object.</p>
        </div>

        <div class="tw-sticky tw-bottom-0 tw-z-[6] tw-mt-2 tw-flex tw-justify-end tw-bg-gradient-to-b tw-from-transparent tw-from-0% tw-to-white tw-to-[28%] tw-pb-1 tw-pt-3">
          <button
            type="button"
            class="tw-cursor-pointer tw-rounded-xl tw-border-0 tw-bg-blue-600 tw-px-6 tw-py-3 tw-text-sm tw-font-bold tw-text-white hover:tw-bg-blue-700 disabled:tw-cursor-not-allowed disabled:tw-opacity-50"
            [disabled]="!canApply"
            (click)="applyPatch()"
          >
            {{ isSaving ? 'Saving...' : 'Save changes' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
